export default __webpack_public_path__ + "static/media/bateria4.3b0ea1e5.png";